module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "d_parent",
    staticClass: "other-cal",
    class: {
      'other-cal--active': _vm.isDropDown
    }
  }, [_c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.setDropdownFromClick),
      expression: "setDropdownFromClick"
    }],
    staticClass: "other-cal__selected d-input",
    on: {
      "click": _vm.setDropdown
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.selectedCalendar))]), _vm._v(" "), _c('span', {
    staticClass: "icon-menu-open"
  })]), _vm._v(" "), (_vm.isDropDown) ? _c('ul', {
    ref: "d_child",
    staticClass: "other-cal__options",
    class: {
      'd-dropdown--animate': _vm.isPopperReady,
      'd-dropdown--show': _vm.isPopperDone
    }
  }, [_c('li', {
    class: {
      'item--active': _vm.selectedCalendarId === null
    },
    on: {
      "click": function($event) {
        return _vm.selectCalendar(null)
      }
    }
  }, [_c('span', {
    staticClass: "icon-users"
  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['own_calendars']) + "\n    ")]), _vm._v(" "), _vm._l((_vm.otherCalendars), function(calendar) {
    return _c('li', {
      key: calendar.id,
      class: {
        'item--active': _vm.selectedCalendarId === calendar.id
      },
      on: {
        "click": function($event) {
          return _vm.selectCalendar(calendar.id)
        }
      }
    }, [_c('span', {
      staticClass: "icon-clipboard2"
    }), _vm._v(" " + _vm._s(calendar.name) + "\n    ")])
  })], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-09fb3b83!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SubjectsDistribution/SubjectsDistributionTasksCreateDropdown.vue
// module id = 1752
// module chunks = 1